export default "assets/linkedin-6d8306dd.svg";